<template>
  <div class="section">
    <div class="section-header"><h3>배송정보</h3></div>
    <div class="section-body">
      <dl class="field-group">
        <dt class="field-label">
          수취인명
        </dt>
        <dd class="field-control">
          <div class="field-control-sub">
            <p class="data-text">{{ registration.dlvRcipNmMask }}</p>
          </div>
        </dd>
      </dl>

      <dl class="field-group">
        <dt class="field-label">
          주소
        </dt>
        <dd class="field-control">
          <div class="field-control-sub">
            <p class="data-text">
              <span>{{ registration.dlplZpcd }}</span
              ><br />
              <span class="input-sub-text">{{ registration.dlplBadr }}</span
              >
              <!-- 상세주소 제거 -->
              <!-- <br />
              <span class="input-sub-text">{{ registration.dlplDadr }}</span> -->
            </p>
          </div>
        </dd>
      </dl>

      <dl class="field-group">
        <dt class="field-label">
          수취인 연락처1
        </dt>
        <dd class="field-control">
          <div class="field-control-sub">
            <p class="data-text">
              <span>{{ dlplTlnoMask }}</span>
            </p>
          </div>
        </dd>
      </dl>

      <dl class="field-group" v-if="registration.dlvCtplNm !== ''">
        <dt class="field-label">
          수취인 연락처2
        </dt>
        <dd class="field-control">
          <div class="field-control-sub">
            <p class="data-text">
              <span>{{ dlplTlno2Mask }}</span>
            </p>
          </div>
        </dd>
      </dl>

      <!--              <dl class='field-group'>-->
      <!--                <dt class='field-label'>-->
      <!--                  수취인 연락처2-->
      <!--                </dt>-->
      <!--                <dd class='field-control'><div class='field-control-sub'>-->
      <!--                  <p class='data-text'>{{step2.shipToAddr.telNo2}}</p>-->
      <!--                </dd>-->
      <!--              </dl>-->
      <dl class="field-group" v-if="registration.addReqMttrCntn">
        <dt class="field-label">
          추가요청사항
        </dt>
        <dd class="field-control">
          <div class="field-control-sub">
            <p class="data-text">{{ registration.addReqMttrCntn }}</p>
          </div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShipToAddrSectionView',

  props: {
    registrationProps: Object
  },

  data() {
    return {
      registration: {},
      dlplTlnoMask: '',
      dlplTlno2Mask: '',
    }
  },

  mounted() {
    this.registration = this.registrationProps
    this.dlplTlnoMask = this.formatPhoneNumber(this.registration.dlplTlnoMask)
    this.dlplTlno2Mask = this.formatPhoneNumber(this.registration.dlplTlno2Mask)
  },

  methods: {
    /** 
     * Function    : formatPhoneNumber
     * Description : 휴대폰 번호 formatting
     **/
    formatPhoneNumber(phoneNum) {
      if (phoneNum.length === 10) {
        return (
          phoneNum.substring(0, 3) +
          '-' +
          phoneNum.substring(3, 6) +
          '-' +
          phoneNum.substring(6, 10)
        )
      } else {
        return (
          phoneNum.substring(0, 3) +
          '-' +
          phoneNum.substring(3, 7) +
          '-' +
          phoneNum.substring(7, 11)
        )
      }
    }
  }
}
</script>

<style scoped></style>
